import { render, staticRenderFns } from "./SociosLayout.vue?vue&type=template&id=651f85ac&scoped=true&"
import script from "./SociosLayout.vue?vue&type=script&lang=js&"
export * from "./SociosLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f85ac",
  null
  
)

export default component.exports